export const weekdayShortTranslations = (weekday?: string) => {
  if (weekday === 'Monday') return 'common:mondayShort'
  if (weekday === 'Tuesday') return 'common:tuesdayShort'
  if (weekday === 'Wednesday') return 'common:wednesdayShort'
  if (weekday === 'Thursday') return 'common:thursdayShort'
  if (weekday === 'Friday') return 'common:fridayShort'
  if (weekday === 'Saturday') return 'common:saturdayShort'
  if (weekday === 'Sunday') return 'common:sundayShort'
  return weekday
}

export const isWeekdaySunday = (index: number) => index <= 6
